import './js/preloader';

import './js/trending-films-render';

import './js/film-modal-render';

import './js/search-films';

import './js/open-md-win-our-team';

import './js/slider';

import './js/swiper-slide';

import './js/open-modal-top-list';

